import FormattedReport from "./FormattedReport";

export {FormattedReport};